export default {"src":"/_next/static/media/low-transaction-fees.c062b630.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};